// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles__spinner___6cyEy","spinner-fade-out":"styles__spinner-fade-out___3PjFJ"};